<template>
  <div class="shortcode-selection-dialog">
    <v-form ref="form" v-model="isFormValid">
      <v-row>
        <v-col cols="12">
          <v-autocomplete
            v-model="selectedShortcode"
            :items="shortcodesList"
            label="Search and select design element"
            placeholder="Type to search or select..."
            :menu-props="{ offsetY: true, offsetOverflow: true }"
            item-text="text"
            item-value="value"
            return-object
            clearable
            :rules="[v => !!v || 'Please select a design element']"
            @input="onShortcodeSelected">
            <template v-slot:append>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M7.41 8.58008L12 13.1701L16.59 8.58008L18 10.0001L12 16.0001L6 10.0001L7.41 8.58008Z"
                  fill="#939099" />
              </svg>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
  export default {
    name: "ShortcodeSelectionDialog",
    data() {
      return {
        isFormValid: false,
        selectedShortcode: null,
        shortcodesList: [],
      };
    },
    mounted() {
      this.initializeDialog();
      this.setupMessageListener();
      this.setupButtonHandlers();
    },
    methods: {
      initializeDialog() {
        // Request initial data from TinyMCE
        this.sendMessageToTinyMCE("requestData");
      },
      setupMessageListener() {
        window.addEventListener("message", this.handleMessage);
      },
      setupButtonHandlers() {
        // Listen for TinyMCE button clicks
        window.addEventListener("message", event => {
          if (event.data.mceAction === "needValidation") {
            this.validateAndSubmit();
          }
        });
      },
      handleMessage(event) {
        if (event.data.mceAction === "sendData") {
          this.shortcodesList = event.data.data || [];
        }

        if (event.data.mceAction === "needValidation") {
          this.validateAndSubmit();
        }
      },
      sendMessageToTinyMCE(type, data = null) {
        if (window.parent) {
          window.parent.postMessage(
            {
              mceAction: type,
              data: data,
            },
            "*",
          );
        }
      },
      onShortcodeSelected(shortcode) {
        this.selectedShortcode = shortcode;
      },
      validateAndSubmit() {
        if (this.$refs.form.validate()) {
          this.sendMessageToTinyMCE("updateSelectedShortcode", {
            shortcode: this.selectedShortcode,
            isValid: true,
          });

          return true;
        } else {
          this.sendMessageToTinyMCE("validation", {
            isValid: false,
          });

          return false;
        }
      },
    },
    beforeDestroy() {
      window.removeEventListener("message", this.handleMessage);
    },
  };
</script>

<style scoped>
  .shortcode-selection-dialog {
    padding: 13px;

    margin: 0 auto;
  }
</style>
